@layer design-system {
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .dropdownListContainer {
    z-index: var(--z-index-dropdown);
    position: relative;
    display: flex;
    flex-direction: column;
  }
}
